import api from '../api'

export default {
    namespaced: true,
    state: {
        newsInterval: null,
        messageUnreadCount: 0,
        messageList: {
            beanList: [],
            total: 0
        }
    },
    mutations: {
        setStateNewsInterval(state, {info, clear = false}) {
            if (clear) {
                clearInterval(state.newsInterval);
                state.newsInterval = null;
            } else {
                info();
                state.newsInterval = setInterval(() => {
                    info()
                }, 5000);
            }
        },
        setStateMessageUnreadCount(state, info) {
            state.messageUnreadCount = info
        },
        setStateMessageList(state, info) {
            state.messageList = info
        }
    },
    actions: {
        intervalNews({commit, dispatch}) {
            commit('setStateNewsInterval', {
                info: () => {
                    dispatch('getMessageUnreadCount')
                }
            })
        },
        getMessageUnreadCount({state,commit}) {
            return api.post('/osmMessages/countUnread', '消息-未读消息计数').then(res => {
                if (res.data > state.messageUnreadCount) {
                    document.getElementById('newsAudio').play()
                }
                commit('setStateMessageUnreadCount', res.data);
            })
        },
        getMessageList({commit}, page) {
            return api.post('/osmMessages/list', '消息-列表', {page}).then(res => {
                commit('setStateMessageList', res.data)
            })
        },
        readMessage({dispatch}, msgId) {
            return api.post('/osmMessages/read', '消息-标记消息状态为已读', {msgId}).then(() => {
                dispatch('getMessageUnreadCount');
            })
        },
        readAllMessage({dispatch}) {
            return api.post('/osmMessages/readAll', '消息-全部已读').then(() => {
                dispatch('getMessageUnreadCount');
            })
        }
    }
}